export { DMS_MODULE } from '../constants';
export const CRUMB_LABEL_KEY = 'edtZakazkaJfnd';


export const NAME = 'JednotnaFrontaNd';
export const NAHRADY = 'Nahrady';
export const PARTS_ISSUED = 'Parts Issued';
export enum JFND_ZPRACREZIM_PZN {
	AKTUALNE_VYBRANY_ND = 1, //  AKTND
	HROMADNA_OBJEDNAVKA = 2, //	HROBJ
	HROMADNY_VYDEJ = 3, //	HRVYD
	HROMADNY_VYDEJ_S_NAHRADOU = 4, //	HRVYN
	HROMADNA_REZERVACE = 5, //	HRREZ
}

export enum ZDROJ {
	BTAC = 1, REZERV = 2, SP = 3, KOS = 4, E_SHOP_NORA = 5, SDA = 6, EAN_TERM = 7, ELSA = 8,
	ND_KLON = 9, PL = 10, PPSO = 11, SILVER_DAT = 16, AUDA_TEX = 17, E_SHOP_SA = 18,
	DMS_CZSK = 20, KOS_BLOK = 21,
}

export enum Mio {
	RychlaObjednavka = 1,
	SkladovaObjednavka = 2,
	InteligentNdObjednavka = 3,
}

export const ND_NR_PLUS = 'ND_NR_PLUS';

export const GRID_COLUMNS = {
	ND_NR_PLUS,
};
